export default {
    state: {
        all: [],
        filtered: [],
        selectedUser: []
    },
    actions: {
        fetchCurrentUser({ commit }) {
            return axios.get('/api/get-current-user').then(user => {
                commit('setUser', user.data)
            }).catch(response => {
                console.error(response);
            });
        }
    },
    mutations: {
        setUser(state, user) {
            state.selectedUser = user
        }
    },
};
